import { createAxios, createAxiosHeaders } from "./axiosHttpMarconi";
import { franquiciaService } from "./franquicia.service";

export const expedienteMedidaService = {
  getExpedientesMedidas,
  postExpedienteMedida,
  getExpedienteMedidaById,
  getExcel,
  putExpedienteMedida,
};

function getExpedientesMedidas(pagination, filters) {
  const axios = createAxios();
  const franquicia = franquiciaService.getLocalFranquicia();
  let urlPath = `franquicia/${franquicia._id}/expedientes-medidas`;
  const pagination_service = {
    page: pagination.currentPage - 1,
    limit: pagination.perPage,
  };

  const params = new URLSearchParams({ ...pagination_service, ...filters });

  urlPath += `?${params.toString()}`;
  return axios.get(urlPath);
}

function postExpedienteMedida(request) {
  const axios = createAxios();
  const franquicia = franquiciaService.getLocalFranquicia();
  let urlPath = `franquicia/${franquicia._id}/expedientes-medidas`;
  return axios.post(urlPath, request);
}

function getExpedienteMedidaById(id) {
  const axios = createAxios();
  const franquicia = franquiciaService.getLocalFranquicia();
  let urlPath = `franquicia/${franquicia._id}/expedientes-medidas/${id}`;
  return axios.get(urlPath);
}

function getExcel(filters) {
  const axios = createAxiosHeaders();
  const franquicia = franquiciaService.getLocalFranquicia();
  let urlPath = `/franquicia/${franquicia._id}/expedientes-medidas/excel`;
  const params = new URLSearchParams({ ...filters, ...{ limit: 2000 } });
  urlPath += `?${params.toString()}`;

  return axios.get(urlPath, { responseType: "blob" }).then((response) => {
    const contentDisposition = response.headers["content-disposition"];
    const fileName = contentDisposition;
    return Promise.resolve({ blob: response.data, fileName: fileName });
  });
}

function putExpedienteMedida(id, request) {
  const axios = createAxios();
  const franquicia = franquiciaService.getLocalFranquicia();
  let urlPath = `franquicia/${franquicia._id}/expedientes-medidas/${id}`;
  return axios.put(urlPath, request);
}
